import { makeStyles } from "@material-ui/core/styles";

const drawerWidth = 210;
const useStyles = makeStyles((theme) => ({
  "@keyframes backgroundColorChange": {
    "0%": {
      backgroundColor: "transparent",
    },
    "100%": {
      backgroundColor: theme.palette.secondary.main,
    },
  },
  "@keyframes slideIn": {
    "0%": {
      transform: "translateX(100%)",
      opacity: 0,
    },
    "100%": {
      transform: "translateX(0)",
      opacity: 1,
    },
  },
  root: {
    background: theme.palette.primary.main,
    minHeight: "100vh",
    display: "flex",
  },
  bellIconAnimated: {
    backgroundColor: theme.palette.secondary.main,
    padding: "4px 4px 4px 8px",
    display: "flex",
    alignItems: "center",
    gap: "6px",
    borderRadius: "5px",
    animation: `$backgroundColorChange 1s ease-in-out`,
  },
  animatedSpan: {
    animation: `$slideIn 0.5s ease-in-out`,
  },
  appBar: {
    background: theme.palette.primary.main,
    height: "75px",
    justifyContent: "space-between",
    zIndex: theme.zIndex.drawer + 1,
    boxShadow: "none",
    paddingLeft: "0%",
    paddingRight: "0%",
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  projectNameAndImage: {
    width: "100%",
    // marginLeft: "5.5%",
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  projectThumbnail: {
    height: "36px",
    width: "36px",
    borderRadius: "10px",
    objectFit: "cover",
  },
  searchInput: {
    padding: "0.2px 6px",
    width: "60%",
    background: theme.palette.secondary.light,
    fontFamily: "Nunito Sans",
    fontStyle: "normal",
  },
  searchDiv: {
    backgroundColor: theme.palette.secondary.light,
    borderRadius: "10px",
    width: "30%",
    height: "46px",
    display: "flex",
    alignItems: "center",
    color: theme.palette.text.primary,
  },
  menuButton: {
    marginRight: 36,
    color: theme.palette.text.primary,
  },
  hide: {
    display: "none",
  },
  drawer: {
    background: theme.palette.secondary.light,
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap",
    zIndex: "1202",
    borderRadius: "10px",
    position: "fixed",
    margin: "20px",
  },
  paperAnchorDockedLeft: {
    borderRightWidth: "0px",
  },
  drawerOpen: {
    background: theme.palette.secondary.light,
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    background: theme.palette.secondary.light,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(10) + 1,
    },
  },
  toolbar: {
    height: "75px",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  },
  topToolbar1: {
    padding: "0px 0px 0px 24px",
    minHeight: "42px",
    backgroundColor: "#252A38",
    display: "flex",
    alignItems: "center",
    gap: "20px",
  },
  topToolbar: {
    // paddingTop: "10px",
    minHeight: "62px",
    justifyContent: "space-between",
  },
  extrProjectName: {
    display: "flex",
    alignItems: "center",
    gap: "50px",
  },
  simpleProjectName: {
    // marginLeft: "5.5%",
  },
  contentOpen: {
    flexGrow: 1,
    padding: theme.spacing(3),
    paddingLeft: "8rem",
    transition: theme.transitions.create(["width", "padding"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: "100%",
  },
  contentClose: {
    flexGrow: 1,
    padding: theme.spacing(3),
    paddingTop: "0px",
    transition: theme.transitions.create(["width", "padding"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: "100%",
  },
  reviewerContent: {
    flexGrow: 1,
    padding: theme.spacing(3),
    paddingLeft: "15rem",
  },
  topBarIcon: {
    color: theme.palette.text.primary,
    width: "max-content",
    minWidth: "max-content",
    padding: "5px",
  },
  myTeamsButton: {
    color: theme.palette.text.primary,
    border: `2px solid ${theme.palette.secondary.main}`,
    borderRadius: "10px",
    padding: "6px 16px",
    textAlign: "center",
    marginRight: "8px",
  },
  icon: {
    color: theme.palette.text.primary,
  },
  title: {
    color: theme.palette.text.primary,
    fontFamily: "Poppins",
    fontStyle: "normal",
    fontWeight: "800",
    fontSize: "20px !important",
    lineHeight: "58px",
    letterSpacing: "1.5px",
  },
  sideBarIconsColor: {
    color: theme.palette.text.primary,
  },
  closeSidebar: {
    "&:hover": {
      color: theme.palette.secondary.main,
      cursor: "pointer",
    },
  },

  sideBarList: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    paddingLeft: "0",
  },

  sideBarListOpen: {
    display: "flex",
    flexDirection: "column",
    paddingLeft: "0",
  },

  rightArrowIcon: {
    marginLeft: "2px",
    height: "30px",
    borderRadius: "50%",
    width: "30px",
    borderRadius: "50%",
    background: theme.palette.secondary.light,
  },

  searchBar: {
    width: "30%",
    borderRadius: "10px",
    background: theme.palette.secondary.light,
  },
  sideBarDiv: {
    paddingLeft: "10px",
  },
  paperAnchorDockedLeft: {
    borderRight: "0px",
  },
  iconDiv: {
    padding: "10px",
    width: "100%",
    alignItems: "center",
    color: theme.palette.text.primary,
    justifyContent: "center",
    display: "flex",

    border: `3px solid ${theme.palette.secondary.light}`,
    "&:hover": {
      color: theme.palette.text.primary,
      cursor: "pointer",
      backgroundColor: theme.palette.primary.main,
      borderRadius: "10px",
      border: `3px solid ${theme.palette.secondary.dark}`,
    },
    [theme.breakpoints.down("lg")]: {
      padding: "6px",
    },
  },
  selected: {
    background: theme.palette.primary.main,
    color: theme.palette.text.primary,
    border: `3px solid ${theme.palette.secondary.dark}`,
    borderRadius: "10px",
  },
  text: {
    color: theme.palette.text.primary,
    fontSize: "14px",
  },
  popoverArrow: {
    position: "absolute",
    borderRadius: "5px",
    left: "71%",
    top: "-23px",
    borderLeft: "25px solid transparent",
    borderRight: "25px solid transparent",
    borderBottom: `25px solid ${theme.palette.primary.main}`,
    width: "0",
    height: "0",
    zIndex: "100",
  },
  popoverArrowTriangle: {
    borderRadius: "3px",
    marginLeft: "71%",
    borderLeft: "25px solid transparent",
    borderRight: "25px solid transparent",
    borderBottom: `25px solid ${theme.palette.secondary.main}`,
    width: "0",
    height: "0",
    zIndex: "100",
  },
  iconsize: {
    height: "30px !important",
    width: "30px !important",
    [theme.breakpoints.down("lg")]: {
      height: "20px !important",
      width: "20px !important",
    },
  },
  userNameAvatar: {
    width: "30px",
    height: "30px",
    backgroundColor: "#6C65D9",
    borderRadius: "50%",
    color: "black",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "14px",
    fontWeight: "500",
  },
  flexCenter: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  navItemWrapper: {
    display: "inline-flex",
    alignItems: "center",
    flexShrink: 0,
    minWidth: "max-content",
    height: "100%",
  },
  navButton: {
    "&.MuiButton-root": {
      backgroundColor: "transparent",
      color: "#B1B5C9",
      borderRadius: "0px",
      boxShadow: "none",
      padding: "10px 18px",
      height: "100%",
      whiteSpace: "nowrap",
      minWidth: "max-content",
    },
  },
  navButtonSelected: {
    "&.MuiButton-root": {
      backgroundColor: "#1B1D28",
      color: "#F9F9F9",
    },
  },
  navButtonIconOnly: {
    "&.MuiButton-root": {
      padding: "10px 12px",
      minWidth: "auto",
    },
  },
  moreButton: {
    "&.MuiButton-root": {
      backgroundColor: "transparent",
      color: "#B1B5C9",
      borderRadius: "0px",
      padding: "10px 12px",
      boxShadow: "none",
      height: "100%",
      whiteSpace: "nowrap",
    },
  },
  hiddenMeasure: {
    position: "fixed",
    top: 0,
    left: -10000,
    visibility: "hidden",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    height: "auto",
    zIndex: -1,
  },
  navLink: {
    textDecoration: "none",
    height: "100%",
  },
}));

export default useStyles;
